<template>
  <div>
    <Sector class="mb-5">
      <BNav align="center" class="featured-experience">
        <BNavText
          active
          class="featured-content featured-merch"
          :class="{ 'featured-merch-local': localExperience === getMerch }"
          @click="changeLocalExp(getMerch)"
        >
          {{ merchTabText }}
        </BNavText>

        <BNavText
          class="featured-content featured-design"
          :class="{ 'featured-design-local': localExperience === getDesign }"
          @click="changeLocalExp(getDesign)"
        >
          {{ designTabText }}
        </BNavText>
      </BNav>

      <Sector v-if="listExist(`prehome_featured_${localExperience}`)">
        <Grid
          :items="getVectorsList(`prehome_featured_${localExperience}`)"
          @item-click="vectorClick"
        >
          <template #default="slotProps">
            <NormalVectorOverlay :data="slotProps.data" />
          </template>
        </Grid>
      </Sector>

      <Button
        class="d-flex justify-content-center more-button"
        shape="full"
        :color="localExperience + '-color'"
        :to="seeAllLink"
      >
        {{ seeAllText }}
      </Button>
    </Sector>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BNav, BNavText } from 'bootstrap-vue';

import Button from 'UI/Button';
import Grid from '@/components/Common/Grid';
import NormalVectorOverlay from '@/components/Vectors/NormalVectorOverlay';
import Sector from '@/components/Home/Sector';

export default {
  components: {
    BNav,
    BNavText,
    Button,
    Grid,
    NormalVectorOverlay,
    Sector
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      merchTabText: '',
      merchButtonText: '',
      merchButtonPath: '',
      designTabText: '',
      designButtonText: '',
      designButtonPath: '',
      merchIds: [],
      designIds: [],
      localExperience: 'merch'
    };
  },
  async fetch() {
    const { primary } = this.slice;
    this.merchTabText = primary.merch_tab_text && primary.merch_tab_text[0]?.text;
    this.merchButtonText = primary.merch_button_text && primary.merch_button_text[0]?.text;
    this.merchButtonPath = primary.merch_button_path && primary.merch_button_path[0]?.text;
    this.designTabText = primary.design_tab_text && primary.design_tab_text[0]?.text;
    this.designButtonText = primary.design_button_text && primary.design_button_text[0]?.text;
    this.designButtonPath = primary.design_button_path && primary.design_button_path[0]?.text;

    this.merchIds = this.slice.items
      .filter((item) => item.vector_id && item.exp == this.getMerch)
      .map((item) => item.vector_id);

    this.designIds = this.slice.items
      .filter((item) => item.vector_id && item.exp == this.getDesign)
      .map((item) => item.vector_id);

    await this.$store.dispatch('vectors/LOAD_VECTOR_LISTING', {
      name: 'prehome_featured_merch',
      ids: this.merchIds
    });

    await this.$store.dispatch('vectors/LOAD_VECTOR_LISTING', {
      name: 'prehome_featured_design',
      ids: this.designIds
    });
  },
  computed: {
    ...mapGetters('experience', ['getDesign', 'getMerch']),
    ...mapGetters('vectors', ['listExist', 'getVectorsList']),
    seeAllLink() {
      return this.localExperience === this.getDesign ? this.designButtonPath : this.merchButtonPath;
    },
    seeAllText() {
      return this.localExperience === this.getDesign ? this.designButtonText : this.merchButtonText;
    }
  },
  methods: {
    changeLocalExp(exp) {
      this.localExperience = exp;
    },
    async vectorClick({ item, shownListing }, e) {
      e.preventDefault();
      this.$bvModal.show('preview-vector-modal');
      await this.$store.dispatch('vectors/OPEN_PREVIEW', { id: item.id, list: shownListing });
    }
  }
};
</script>

<style lang="scss" scoped>
.featured-content {
  border-bottom: $white solid 2.5px;
  cursor: pointer;
  font-size: 16px;
  padding: 5px 10px;
  margin: 0px 10px;
}
.featured-design {
  color: $designColor;
}
.featured-design-local {
  border-bottom: $designColor solid 2.5px;
}
.featured-experience {
  border-bottom: 0.5px solid rgba(#b7b7b7, 0.5);
  margin-bottom: 10px;
}
.featured-merch {
  color: $merchColor;
}
.featured-merch-local {
  border-bottom: $merchColor solid 2.5px;
}
.more-button {
  margin: 20px 0px;
}
</style>
